import React from "react";

import "./styles/InstallInstructions.css";

export default function installInstructions() {
  return (
    <>
      <header className="header">
        <div className="logo">
          <img src="./logo192.png" alt="rudyairlines overlay" />
          <h1>
            <a href="?home">Rudyairlines Overlay</a>
          </h1>
        </div>
      </header>
      <div className="install-instructions">
        <h2>Install instructions on Streamlabs</h2>
        <p>
          The first step is configure your overlay. Select the template and
          search your user by your username.
        </p>
        <img src="./tutorial/tutorial_01.png" alt="" />
        <p>Now you could copy the URL (we will use it later).</p>
        <img src="./tutorial/tutorial_02.png" alt="" />
        <p>On Streamlabs add a "Browser source:"</p>
        <img src="./tutorial/tutorial_03.png" alt="" />
        <p>
          It's important to configure well width and height. You should
          configure it as a fullscreen layer (we recommend 1920x1080):
        </p>
        <img src="./tutorial/tutorial_04.png" alt="" />
        <p>The Browser source should match with the scene size:</p>
        <img src="./tutorial/tutorial_05.png" alt="" />
        <p>
          You could check your resolution on Settings &gt; Video, on the "Base
          (Canvas) Resolution. We recommend 1920x1080."
        </p>
        <img src="./tutorial/tutorial_06.png" alt="" />
      </div>
    </>
  );
}
